import React, { useState } from "react";
import "./Style/Style.css";
import doctor from "./Assits/doctor.png";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import { registerfunction } from "./services/Apis";
// import Spinner from "react-bootstrap/Spinner";
import "../App.css";
import "react-toastify/dist/ReactToastify.css";
const Reagister = ({setProgress}) => {
  let navigate = useNavigate();

  const [inpval, setInpval] = useState({
    fname: "",
    email: "",
    phone: "",
    password: "",
    cpassword: "",
  });

  const setVal = (e) => {
    const { name, value } = e.target;

    setInpval(() => {
      return {
        ...inpval,
        [name]: value,
      };
    });
  };

  const addUserdata = async (e) => {
    e.preventDefault();

    const { fname, email, phone, password, cpassword } = inpval;

    if (fname === "") {
      toast.warning("full name is required!", {
        position: "top-center",
      });
    } else if (email === "") {
      toast.error("email is required!", {
        position: "top-center",
      });
    } else if (!email.includes("@")) {
      toast.warning("includes @ in your email!", {
        position: "top-center",
      });
    } else if (phone === "") {
      toast.error("phone number is required!", {
        position: "top-center",
      });
    } else if (phone.length !== 10) {
      toast.error("enter valid phone number!", {
        position: "top-center",
      });
    } else if (password === "") {
      toast.error("password is required!", {
        position: "top-center",
      });
    } else if (password.length < 6) {
      toast.error("password is required!", {
        position: "top-center",
      });
    } else if (cpassword === "") {
      toast.error("confirm password must be 6 char!", {
        position: "top-center",
      });
    } else if (password !== cpassword) {
      toast.error("password and confirm password are not matching!", {
        position: "top-center",
      });
    } else {
      // alert("user register successfully")
      setProgress(20)
      setProgress(40)
      setProgress(60)
      const res = await registerfunction(inpval);
      // console.log(res);

      if (res.status === 201) {
        setProgress(80)
        setProgress(100)
        setInpval({
          ...inpval,
          fname: "",
          email: "",
          phone: "",
          password: "",
          cpassword: "",
        });
       
        navigate("/login");
      } else {
        setProgress(80)
        setProgress(100)
        toast.error(
          "Registration will not done please try again with different email !",
          {
            position: "top-center",
          }
        );
        setInpval({
          ...inpval,
          fname: "",
          email: "",
          phone: "",
          password: "",
          cpassword: "",
        });
      }
    }
  };

  return (
    <div>
        <section className="log">
          <div className="login-box regbox">
            <div className="login-img secimg">
              <img src={doctor} alt="" />
            </div>
            <div className="register-contain">
              <h1>Create Your Account</h1>
              <div className="input-box">
                <i className=" fas fa-solid fa-user"></i>
                <input
                  type="text"
                  value={inpval.fname}
                  onChange={setVal}
                  name="fname"
                  placeholder="Full Name"
                />
              </div>
              <div className="input-box">
                <i className="fas fa-solid fa-envelope"></i>
                <input
                  type="text"
                  onChange={setVal}
                  value={inpval.email}
                  name="email"
                  placeholder="Your Email"
                />
              </div>
              <div className="input-box">
                <i className="fas fa-solid fa-mobile"></i>
                <input
                  type="text"
                  onChange={setVal}
                  value={inpval.phone}
                  name="phone"
                  placeholder="Phone Number"
                />
              </div>
              <div className="input-box">
                <i className="fas fa-solid fa-lock"></i>
                <input
                  type="password"
                  onChange={setVal}
                  value={inpval.password}
                  name="password"
                  placeholder="Your Password"
                />
              </div>
              <div className="input-box">
                <i className="fas fa-solid fa-lock"></i>
                <input
                  type="password"
                  onChange={setVal}
                  value={inpval.cpassword}
                  name="cpassword"
                  placeholder="Confirm Password"
                />
              </div>
              <div className="register-btn">
                <button className="bt" onClick={addUserdata}>
                  Create Now
                </button>
              </div>
            </div>
            <ToastContainer />
          </div>
        </section>
    </div>
  );
};

export default Reagister;
